export default {"src":"/_next/static/media/location.e4187234.svg","height":19,"width":16,"blurWidth":0,"blurHeight":0};